import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { STATE_COLORS, FEDERAL_COLOR } from '../constants/stateColors';
import { State } from '../types';

const ALL_STATES: State[] = ['WA', 'NT', 'SA', 'QLD', 'NSW', 'ACT', 'VIC', 'TAS'];

export const StateColorKey: React.FC = () => {
  return (
   <Paper 
      elevation={0} 
      sx={{ 
        p: 2, 
        mt: 1, 
        bgcolor: 'rgba(0,0,0,0.02)',
        border: '1px solid rgba(0,0,0,0.1)',
      }}
    > <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Federal holidays */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          sx={{
            width: 16,
            height: 16,
            backgroundColor: FEDERAL_COLOR,
            borderRadius: 0.5,
          }}
        />
        <Typography variant="caption" sx={{ fontSize: '0.85rem' }}>
          Federal
        </Typography>
      </Box>

      {/* States */}
      {ALL_STATES.map((state) => (
        <Box key={state} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 16,
              height: 16,
              backgroundColor: STATE_COLORS[state],
              borderRadius: 0.5,
            }}
          />
          <Typography variant="caption" sx={{ fontSize: '0.85rem' }}>
            {state}
          </Typography>
        </Box>
      ))}
    </Box></Paper>
  );
};
